<div class="layout">
  <app-navbar></app-navbar>
  <!-- Sidebar -->
  <div #sideBar class="sidebar leftSidebar">
    <app-sign-vk *ngIf="!vkService.isAuth"></app-sign-vk>
    <tabset *ngIf="vkService.isAuth" #staticTabs class="tab-icons d-block" type="pills">
      <tab>
        <ng-template tabHeading>
          <i-feather tooltip="Беседы" placement="bottom" name="message-square" class="icon-lg"></i-feather>
        </ng-template>
        <div>
          <app-chat-list
            [Service]="vkService"
            (onSettings)="selectTab(2)"
            *ngIf="vkService.isAuth"
            [type]="'telegram'"
          ></app-chat-list>
        </div>
      </tab>
      <tab>
        <ng-template tabHeading>
          <i-feather tooltip="Написать" placement="bottom" name="edit" class="icon-lg"></i-feather>
        </ng-template>
        <app-chat-new [Service]="vkService" (onClose)="selectTab(0)"></app-chat-new>
      </tab>
      <tab>
        <ng-template tabHeading>
          <i-feather tooltip="Профиль" placement="bottom" name="user" class="icon-lg"></i-feather>
        </ng-template>
        <app-profile [Service]="vkService" class="h-100"></app-profile>
      </tab>
    </tabset>
  </div>
  <!-- tabs.html -->
  <!-- Sidebar -->
  <!-- Main Content -->
  <div class="main w-100" [class.chat-media-open]="interfaceService.showTabsInput">
    <ng-template [ngIf]="vkService.isAuth">
      <app-chat-show
        class="w-100"
        (onNewChat)="selectTab(1)"
        (onOpenProfile)="selectTab(2)"
        [Service]="vkService"
      ></app-chat-show>
    </ng-template>
    <app-page-start-content *ngIf="!vkService.isAuth"></app-page-start-content>
  </div>
  <!-- Main Content -->
</div>
